/**
 * Recency classifier for the multi-day "N-day runner" badge — is a repeat runner still HOT (ranked in
 * the most recent session) or FADING (it qualified over the window but has not ranked in the last few
 * sessions)? Itay asked for exactly this: tell a hot N/10 from a fading one (request-regulars-runner-feature).
 *
 * Pure and dependency-free ON PURPOSE: it is imported by both server data files (runnerBadges.ts,
 * regulars.ts) AND client components (RunnerDaysBadge, dashboards, feed). It must not pull in `db`, or a
 * client bundle would try to import server code. Keep it that way.
 *
 * `sessionsAgo` is how many completed sessions have passed since a symbol last held a Top-6 slot within
 * the lookback window: 0 = it ranked in the most recent session. A negative or missing value means the
 * data predates this field (an old cache entry), so we classify it as unknown and show no extra flair.
 */
export type RunnerRecency = 'hot' | 'fading' | null

/** Sessions without a Top-6 slot before a runner is called "fading". 1 session off is still "steady"
 *  (a name that ranked yesterday but not in the latest snapshot is not yet cooling), so the bar is 2. */
export const RUNNER_FADING_AFTER_SESSIONS = 2

export function runnerRecency(sessionsAgo: number | null | undefined): RunnerRecency {
  if (sessionsAgo == null || sessionsAgo < 0) return null // unknown (pre-field cache) → no flag
  if (sessionsAgo === 0) return 'hot'
  if (sessionsAgo >= RUNNER_FADING_AFTER_SESSIONS) return 'fading'
  return null // exactly 1 session ago → steady, no extra flair
}
